import { capitalize } from "lodash";
import { Input } from "@/app/admin/_common/ui/input";
import FilterDropdown from "@/app/admin/_common/ui/filter-dropdown";
import type { LinkTaxonomy } from "./linkForm/useLinkTaxonomy";
import { Search } from "lucide-react";

function taxonomyOptions(items: LinkTaxonomy[]) {
  return [
    { value: "all", label: "All" },
    ...items.map((item) => ({ value: item.name, label: capitalize(item.name) })),
  ];
}

export default function LinksToolbar({
  search,
  onSearchChange,
  sourceFilter,
  onSourceFilterChange,
  mediumFilter,
  onMediumFilterChange,
  sources,
  mediums,
}: {
  search: string;
  onSearchChange: (value: string) => void;
  sourceFilter: string;
  onSourceFilterChange: (value: string) => void;
  mediumFilter: string;
  onMediumFilterChange: (value: string) => void;
  sources: LinkTaxonomy[];
  mediums: LinkTaxonomy[];
}) {
  return (
    <div className="flex flex-wrap items-center gap-2">
      <div className="relative max-w-[420px] flex-1">
        <div className="pointer-events-none absolute inset-y-0 left-3 flex items-center">
          <Search className="size-3.5 text-muted-foreground" />
        </div>
        <Input
          type="search"
          placeholder="Search name or redirect…"
          value={search}
          onChange={(e) => onSearchChange(e.target.value)}
          className="h-[30px] pl-9 text-[12.5px]"
          aria-label="Search links"
        />
      </div>

      <FilterDropdown
        label="Source"
        value={sourceFilter}
        onChange={onSourceFilterChange}
        options={taxonomyOptions(sources)}
      />

      <FilterDropdown
        label="Medium"
        value={mediumFilter}
        onChange={onMediumFilterChange}
        options={taxonomyOptions(mediums)}
      />
    </div>
  );
}
